// ======================================================================
// File: purchaseOrderService.js
// Module: PPE → Procurement → Purchase Order
//
// Purpose:
// - API integration layer for Purchase Order module
// - Wrapper over axiosClient (same pattern as rfqService.js)
// - Standard response handling
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

// FIXED BASE URL TO MATCH BACKEND ROUTES
const BASE_URL = "/api/ppe/material-flow/purchase-order";
const EDIT_BASE_URL = "/api/ppe/material-flow/purchase";

//const BASE_URL = "/api/ppe/material-flow/purchase/po";

const purchaseOrderService = {

  // -------------------------------------------------------------
  // CREATE DIRECT PO
  // -------------------------------------------------------------
  createDirectPO: async (payload) => {
    try {
      const response = await axiosClient.post(
        `${BASE_URL}`,
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data?.message || "Failed to create PO";
    }
  },

  // -------------------------------------------------------------
  // CREATE PO FROM RFQ
  // -------------------------------------------------------------
  createFromRFQ: async (rfqId) => {
    try {
      const response = await axiosClient.post(
        `${BASE_URL}/create-from-rfq`,
        {
          rfq_id: rfqId,
        }
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data?.message || "Failed to create PO from RFQ";
    }
  },

  // -------------------------------------------------------------
  // UPDATE EXISTING PO (DRAFT ONLY)
  // -------------------------------------------------------------
  updatePO: async (poId, payload) => {
  try {
    const response = await axiosClient.post(
      `/api/ppe/material-flow/purchase-order/${poId}/edit`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to update PO";
  }
},




  // -------------------------------------------------------------
  // GET PO LIST
  // -------------------------------------------------------------
  getPOList: async (params = {}) => {
    try {
      const response = await axiosClient.get(
        `${BASE_URL}`,
        { params }
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data?.message || "Failed to load purchase orders";
    }
  },

  // -------------------------------------------------------------
  // GET SINGLE PO DETAIL
  // -------------------------------------------------------------
  getPODetail: async (poId) => {
    try {
      const response = await axiosClient.get(
        `${BASE_URL}/${poId}`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data?.message || "Failed to load PO details";
    }
  },

  // -------------------------------------------------------------
  // APPROVE PO
  // -------------------------------------------------------------
  approvePO: async (poId) => {
    try {
      const response = await axiosClient.post(
        `${BASE_URL}/${poId}/approve`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data?.message || "Failed to approve PO";
    }
  },

    // -------------------------------------------------------------
  // SUBMIT PO FOR APPROVAL
  // -------------------------------------------------------------
  submitForApproval: async (poId) => {
    try {
      const response = await axiosClient.post(
        `${BASE_URL}/${poId}/submit-for-approval`
      );
      return response.data;
    } catch (error) {
      throw (
        error?.response?.data?.message ||
        "Failed to submit PO for approval"
      );
    }
  },
  
  // -------------------------------------------------------------
  // SEND PO TO VENDOR
  // -------------------------------------------------------------
  sendPO: async (poId) => {
    try {
      const response = await axiosClient.post(
        `${BASE_URL}/${poId}/send`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data?.message || "Failed to send PO to vendor";
    }
  },
  // -------------------------------------------------------------
// CLOSE PO
// -------------------------------------------------------------
closePO: async (poId, reason) => {
  try {
    const response = await axiosClient.post(
      `${BASE_URL}/${poId}/close`,
      {
        reason
      }
    );

    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message ||
      "Failed to close PO"
    );
  }
},

  // -------------------------------------------------------------
  // GET PO TRACEABILITY
  // -------------------------------------------------------------
  getPOTrace: async (poId) => {
    try {
      const response = await axiosClient.get(
        `${BASE_URL}/${poId}/trace`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data?.message || "Failed to load PO trace";
    }
  },

};




export default purchaseOrderService;
